import { Reveal, SectionLabel } from "@/components/Reveal";

const STANDARDS = [
  { n: "01", name: "Durability", body: "Built to outlast the job site — abrasion, weather and time. 1680D ballistic nylon, bar-tack reinforcement, molded waterproof bases." },
  { n: "02", name: "Reliability", body: "Every component is tested beyond real-world abuse before it earns the patch. If it can fail on site, it doesn't ship." },
  { n: "03", name: "Functionality", body: "Every pocket, loop and panel earns its place. Nothing decorative, nothing wasted — storage designed around how trades actually work." },
  { n: "04", name: "Professional Design", body: "Gear you're proud to carry on site and off. Industrial, minimal, deliberate — designed like equipment, not luggage." },
  { n: "05", name: "Lifetime Mindset", body: "Designed to be repaired, not replaced. We build for decades of daily work — and we stand behind every stitch." },
];

export default function Standards() {
  return (
    <section id="standards" data-testid="standards-section" className="border-t border-zinc-800 bg-[#0D0D0D]">
      <div className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <SectionLabel index="03" title="Our Standards" />
            <h2 className="mt-8 font-display text-4xl font-semibold uppercase leading-none tracking-tight text-zinc-50 sm:text-5xl lg:text-7xl">
              Non-Negotiables
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-zinc-500">
            Five standards govern every decision we make — from material selection to the last stitch.
          </p>
        </Reveal>

        <div className="mt-16 md:mt-24">
          {STANDARDS.map((s, i) => (
            <Reveal key={s.n} delay={0.04 * i} y={20}>
              <div
                data-testid={`standard-row-${s.n}`}
                className="group grid items-baseline gap-4 border-t border-zinc-800 py-10 transition-colors duration-500 last:border-b hover:bg-[#111111] md:grid-cols-12 md:py-12"
              >
                <span className="text-outline-faint select-none font-display text-6xl font-bold leading-none transition-all duration-500 group-hover:text-zinc-700 md:col-span-2 md:text-7xl" style={{ WebkitTextStroke: undefined }}>
                  {s.n}
                </span>
                <h3 className="font-display text-3xl font-semibold uppercase tracking-tight text-zinc-100 transition-transform duration-500 group-hover:translate-x-2 sm:text-4xl lg:text-5xl md:col-span-5">
                  {s.name}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-zinc-400 md:col-span-5">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
